<template>
  <b-card
    v-if="dados"
    no-body
  >
    <b-card-header>
      <h4 class="mb-0">
        {{ title }}
      </h4>
    </b-card-header>

    <!-- apex chart -->
    <vue-apex-charts
      type="radialBar"
      height="235"
      class="my-2"
      :options="goalOverviewRadialBar"
      :series="dados.series"
    />
    <b-row class="text-center mx-0">
      <b-col
        cols="4"
        class="border-top border-right d-flex align-items-between flex-column py-1"
      >
        <b-card-text class="text-muted mb-0">
          Realizado
        </b-card-text>
        <h3 class="font-weight-bolder mb-0">
          {{ valorBr(dados.completed, true) }}
        </h3>
      </b-col>

      <b-col
        cols="4"
        class="border-top d-flex align-items-between flex-column py-1"
      >
        <b-card-text class="text-muted mb-0">
          Meta
        </b-card-text>
        <h3 class="font-weight-bolder mb-0">
          {{ dados.inProgress > 0 ? valorBr(dados.inProgress, true) : 'Definir Meta' }}
        </h3>
      </b-col>
      <b-col
        cols="4"
        class="border-top border-left d-flex align-items-between flex-column py-1"
      >
        <b-card-text class="text-muted mb-0">
          Tendência
        </b-card-text>
        <h3 class="font-weight-bolder mb-0">
          {{ valorBr(tendencia, true) }}
          <span
            class="text-muted"
            style="font-size: 0.75em;"
          >{{ (tendencia / dados.inProgress * 100).toFixed(2) }}%</span>
        </h3>
      </b-col>
    </b-row>

    {{ data }}
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BRow, BCol, BCardText,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
// import axios from '@/../axios-auth'
const $strokeColor = '#ebe9f1'
const $textHeadingColor = '#5e5873'
const $goalStrokeColor2 = '#51e5a8'
export default {
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    BRow,
    BCardText,
    BCol,
  },
  props: {
    title: {
      type: String,
      default: 'Meta',
    },
    dados: {
      type: Object,
      required: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      goalOverviewRadialBar: {
        chart: {
          height: 245,
          type: 'radialBar',
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
        colors: [$goalStrokeColor2],
        plotOptions: {
          radialBar: {
            offsetY: -10,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: '77%',
            },
            track: {
              background: $strokeColor,
              strokeWidth: '50%',
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                color: $textHeadingColor,
                fontSize: '2.86rem',
                fontWeight: '600',
              },
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: [$themeColors.success],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
        grid: {
          padding: {
            bottom: 30,
          },
        },
      },
      tendencia: 0,
    }
  },
  watch: {
    dados: {
      handler(newVal) {
        const diasRestantes = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).getDate() - new Date().getDate()
        const mediaDiaria = newVal.completed / (new Date().getDate() - 1)
        this.tendencia = newVal.completed + (mediaDiaria * diasRestantes)
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
